import { get, patch } from 'store/http/httpAction';
import { setAvailableFields, addToSelection } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import { SET_MODULES } from './actionType';

const setModules = (moduleInfo, objectType) => ({
  type: SET_MODULES,
  payload: { moduleInfo, objectType },
});

export const fetchDefaultSearchLayout = objectType => dispatch =>
  get(`/admin/metadata/search_layout/object/${objectType}/fields/default`, {}, dispatch).then((data) => {
    if (data && data.data) {
      dispatch(setModules(data.data, objectType));
    }
  });

export const fetchObjectAllFields = objectType => (dispatch, getState) =>
  get(`/admin/metadata/object/${objectType}`, {}, dispatch).then((data) => {
    const store = getState();
    const { selectedFields } = store.objectView.fields;
    if (data) {
      const main =
        data.main && _.isArray(data.main.data) ? data.main.data : [];
      const cstm =
        data.cstm && _.isArray(data.cstm.data) ? data.cstm.data : [];
      const columns = [...main, ...cstm];
      dispatch(setAvailableFields(columns, true));
      // reset the selectedFields is due to the function of filter of setAvailableFields need to be uesed
      if (_.isArray(selectedFields)) {
        dispatch(addToSelection(selectedFields));
      }
    }
  });

export const updateModuleColumnsByType = (object_type, moduleFields, cb) => dispatch =>
  patch(`/admin/metadata/search_layout/object/${object_type}/fields/default`, { field_ids: moduleFields }, dispatch).then(data => {
    if (data && _.isArray(data.data)) {
      if (_.isFunction(cb)) {
        cb();
      }
      dispatch(setModules(data.data, object_type));
    }
  });




// WEBPACK FOOTER //
// ./src/views/Setup/SearchLayout/flow/action.js